/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyFSSizeEndpointResponse
 */
export interface ProxyFSSizeEndpointResponse {
    /**
     * 
     * @type {number}
     * @memberof ProxyFSSizeEndpointResponse
     */
    size: number | null;
}

export function ProxyFSSizeEndpointResponseFromJSON(json: any): ProxyFSSizeEndpointResponse {
    return ProxyFSSizeEndpointResponseFromJSONTyped(json, false);
}

export function ProxyFSSizeEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyFSSizeEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'size': json['size'],
    };
}

export function ProxyFSSizeEndpointResponseToJSON(value?: ProxyFSSizeEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'size': value.size,
    };
}


